import React, { useContext, useState } from "react";
import type { EmailSchedule } from "@components/job_alerts/types";
import useTranslation from "@hooks/use_translation";
import { useShowFlash } from "@/sprout/flash";
import { type Option, SingleSelect } from "@sprout/select";
import { router } from "@inertiajs/react";

interface EmailSchedules {
  emailSchedule: EmailSchedule;
  emailSchedules: EmailSchedule[];
  notificationSchedulePath: string;
}

export const EmailSchedulesContext = React.createContext<EmailSchedules>(
  null as unknown as EmailSchedules,
);

const Preferences = () => {
  const { t } = useTranslation("jobAlerts");
  const showFlash = useShowFlash();
  const { emailSchedule, emailSchedules, notificationSchedulePath } =
    useContext(EmailSchedulesContext);

  const scheduleOptions: Option[] = emailSchedules.map((cadence) => ({
    value: cadence,
    label: t(`preferences.${cadence}`),
  }));

  const defaultOption =
    scheduleOptions.find((option) => option.value === emailSchedule) || scheduleOptions[0];

  const [selectedOption, setSelectedOption] = useState<Option>(defaultOption);

  const updateEmailSchedule = async (option: Option) => {
    router.patch(
      notificationSchedulePath,
      { cadence: option.value },
      {
        onFinish: () => {
          showFlash(t("preferences.frequencyUpdated"));
          setSelectedOption(option);
        },
        onError: () => {
          showFlash(t("preferences.updateFailed"), "error");
        },
      },
    );
  };

  return (
    <div className="preferences">
      <SingleSelect
        onChange={(value) => updateEmailSchedule(value as Option)}
        value={selectedOption}
        label=""
        options={scheduleOptions}
      />
    </div>
  );
};

export default Preferences;
